import {IComponentController} from "angular";

import {EmailLength} from "modules/user_settings/model/enums/enums";
import "../../../styles/email-length-selector.scss"
import {LengthOption} from "modules/user_settings/component/email-settings/left-side/left-side";

export class EmailLengthSelector implements IComponentController {
    public emailLengthOptions: Array<LengthOption>;
    public emailLength: EmailLength;
    public updateEmailCallback: (selectedValue: string) => void;

    public static instance = {
        template: require('./email-length-selector.html'),
        controller: EmailLengthSelector,
        bindings: {
            emailLengthOptions: '<',
            emailLength: '<',
            updateEmailCallback: '<'
        }
    };

    updateEmailLength(updatedValue: string) {
        this.updateEmailCallback(updatedValue);
    }


}
